import { Link, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Logout from "@mui/icons-material/Logout";
import MoreIcon from "@mui/icons-material/MoreVert";
import NotificationBell from "@components/custom-components/notification/NotificationBell";

import YuduLogo from "@assets/Yudu-logo.png";
import { Avatar, Button, Grid2, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import ThemeSwitcher from "@components/custom-components/theme-switcher/ThemeSwitcher";
import { MenuOpen } from "@mui/icons-material";
import useDrawerStore from "@setup/store/useDrawerStore";
import { useIsDesktopLayout } from "../../../hooks/useIsDesktopLayout";
import { stringAvatar } from "@utils/helper";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { useAuth } from "../../../context/AuthContext";
import { useOrgBranding } from "../../../hooks/useOrgBranding";

const TopNavigation: React.FC = () => {

  const isMediumScreen = useIsDesktopLayout();

  const navigate = useNavigate();
  const { toggle } = useDrawerStore();
  const { profile: admin, signOut } = useAuth();
  const { logoUrl, orgName } = useOrgBranding();

  const logout = async () => {
    await signOut();
    navigate("/");
  }

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, background: (theme) => theme.palette.background.paper }}
      >
        <Toolbar sx={{ px: 0 }}>
          {!isMediumScreen &&
            <IconButton size='large' onClick={() => toggle()}>
              <MenuOpen />
            </IconButton>
          }
          {/* Fit-the-bar sizing: maxHeight 56 fits the 64px desktop AppBar
              with breathing room (up ~1.4x from 40 for square emblems); maxWidth
              280 keeps a wide wordmark at its previous size so it never
              overflows the bar. */}
          <img
            src={logoUrl ?? YuduLogo}
            alt={orgName}
            style={{ maxHeight: 56, maxWidth: 280, width: "auto", height: "auto" }}
          />


          <Grid2 container ml='auto'>
            <ThemeSwitcher />

            {isMediumScreen && (
              <>
                <NotificationBell />

                <PopupState variant="popover">
                  {(popupState) => (
                    <>
                      <Button size="small" variant="text" color="inherit" {...bindTrigger(popupState)}>
                        <Grid2 container spacing={1.5} justifyContent="center" alignItems="center">
                          <Avatar src={admin?.avatar_url ?? undefined} {...stringAvatar(admin?.first_name && admin?.last_name ? `${admin.first_name} ${admin.last_name}` : 'Administrator')} sx={{ width: 34, height: 34 }} />
                          <Stack spacing={0} sx={{ textTransform: 'capitalize' }} alignItems="start">
                            <Typography sx={{ color: theme => theme.palette.text.primary }} lineHeight="140%">{admin?.first_name && admin?.last_name ? `${admin.first_name} ${admin.last_name}` : 'Administrator'}</Typography>
                          </Stack>
                        </Grid2>
                      </Button>
                      <Menu
                        {...bindMenu(popupState)}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          component={Link}
                          to={`/profile`}
                          onClick={popupState.close}
                        >
                          Profile
                        </MenuItem>
                        <MenuItem onClick={logout}>Sign Out</MenuItem>
                      </Menu>
                    </>
                  )}
                </PopupState>
              </>
            )}

            {!isMediumScreen && (
              <PopupState variant="popover" >
                {(popupState) => (
                  <>
                    <IconButton
                      size="large"
                      {...bindTrigger(popupState)}
                    >
                      <MoreIcon />
                    </IconButton>

                    <Menu
                      {...bindMenu(popupState)}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem
                        onClick={() => { popupState.close(); navigate("/notifications"); }}
                      >
                        <ListItemIcon>
                          <NotificationsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Notifications</ListItemText>
                      </MenuItem>
                      <MenuItem 
                        onClick={popupState.close}
                        component={Link} to={`/root/profile`}
                      >
                        <ListItemIcon>
                          <AccountCircle fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Profile</ListItemText>
                      </MenuItem>
                      <MenuItem 
                        onClick={() => {
                          popupState.close();
                          logout();
                        }}
                      >
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Logout</ListItemText>
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </PopupState>
            )}

          </Grid2>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default TopNavigation;
